import React from "react";
import Link from "next/link";
import PostSideBarAd from "../ads/PostSidebar";

export const PostSidebar = ({ data }) => {
  return <>
    <div>
      <div className="section-title">Categories</div>
      <div>
        {data?.categories?.map((node) => {
          return (
            <Link
              href={node.uri}
              key={node.uri}
              className="bg-block-light inline-flex px-2 py-1 mr-0.5 mb-0.5 hover:bg-primary transition-colors"
            >

              {node.name}

            </Link>
          );
        })}
      </div>
    </div>
    <div
      className="my-4 h-auto"
      style={{ width: 300 }}
    >
      <PostSideBarAd />
    </div>

    <p className="mt-4">
      Instantly play your favorite free online games Play unlimited free games
      at RadCade.com is the best place to go if you’re searching for a variety
      of popular{" "}
      <i>
        <strong>games</strong>
      </i>
    </p>
    <div>
      <div className="section-title">Policies</div>
      <div>
        {data.legalPages.map((page) => (
          (<Link
            href={`/legal/${page.post_name}`}
            key={page.ID}
            className="text-sm hover:text-primary block py-0.5"
          >
            {page.post_title}
          </Link>)
        ))}
      </div>
    </div>
  </>;
};
